<template>
  <div>
    <div
      class="category-button"
      @click="switchTabs"
    >
      <div class="is-size-4 is-uppercase has-text-centered button-title">
        <span class="category-title">
          {{ selectedCategory }}
        </span>
        <font-awesome-icon
          v-show="chevronDown"
          icon="chevron-down"
        />
        <font-awesome-icon
          v-show="!chevronDown"
          icon="chevron-up"
        />
      </div>
    </div>

    <nav
      class="categories-row"
      :class="categoriesClass"
    >
      <div class="navbar-item has-text-centered">
        <div
          v-for="aCategory in categories"
          :key="aCategory"
          :class="categoryClass(aCategory)"
          @click="$emit('selectcategory', aCategory)"
        >
          <p
            class="control is-size-4 is-uppercase category-name"
            @click="closeTabs"
          >
            {{ aCategory }}
          </p>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

export default {

  name: 'TemplateCategories',

  props: {
    categories: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectedCategory: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      categoriesClass: '',
      chevronDown: true
    }
  },
  methods: {
    categoryClass (item) {
      if (item === this.selectedCategory) {
        return 'template_category level-item as-text-centered selected_template'
      }
      return 'template_category level-item as-text-centered'
    },
    select (category) {
      this.$emit('selectCategory', category)
    },
    switchTabs () {
      if (this.categoriesClass === 'show-categories') {
        this.categoriesClass = 'hide-categories'
        this.chevronDown = true
      } else {
        this.categoriesClass = 'show-categories'
        this.chevronDown = false
      }
    },
    closeTabs () {
      this.categoriesClass = 'hide-categories'
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

  .template_category {
    margin-right: 1rem;
    margin-left: 1rem;
    color: #7A7979;
    cursor: pointer;
  }

  .template_category:hover p {
    color: var(--primary-color);
  }

  .category-button {
    width:100%;
    height:30px;
    text-align:center;
    color:#000;
    cursor:pointer;
    background-color: #FFFFFF;
    padding-top: 5px;
    margin-bottom:10px;
    box-shadow: 0 4px 8px 0 rgba(36,39,41,0.1);
  }

  .categories-row {
    display:block;
    background-color:#FFFFFF;
    transition: max-height 1s, overflow 0s;
    transition-timing-function: ease;
    max-height: 0px;
  }

  .navbar-item {
    border-bottom: 1px solid #ecf0f1;
  }

  .show-categories {
    max-height: 100%;
  }

  .hide-categories {
    max-height:0px;
  }

  .selected_template {
    color: var(--primary-color);
  }

  .category-name:hover {
    color: var(--primary-color);
  }

  @media (min-width:1020px) {

    .category-button {
      display: none;
    }

    .categories-row {
      padding-top: 0px;
      display: flex;
      max-height: 50px;
      height: 50px;
      justify-content: center;
    }

    .hide-categories {
      display:flex;
    }

    .navbar-item {
      display: flex;
      border-bottom: 0px;
    }

  }
</style>
